// Carga diferida de la sala: la página pública del evento no descarga el editor, el motor ni el QR.
import { lazy, Suspense } from 'react';
import type { Route } from '../../app/router.tsx';

const Sala = lazy(() => import('./routes.tsx').then((m) => ({ default: m.SalaRoute })));
const Loading = () => <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui', color: '#475569' }}>Cargando la sala…</div>;
const render = (kind: string) => (p: Record<string, string>) => <Suspense fallback={<Loading />}><Sala kind={kind} params={p} /></Suspense>;

export const salaRoutes = (): Route[] => [
  { pattern: '/sala/demo', render: render('demo') },
  { pattern: '/sala/:code', render: render('participant') },
  { pattern: '/sala/:code/pantalla', render: render('screen') },
  { pattern: '/app/cuentas/:account/eventos/:event/sala', render: render('staff') },
  { pattern: '/app/cuentas/:account/eventos/:event/sala/reporte', render: render('report') },
];
